import { and, ControlProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { InputLabel } from '@material-ui/core'
import { authSelectors } from 'ducks/auth'
import { UploadFileInput } from 'opensolar-pageeditor/src/files/components/UploadFileInput'
import { ResourcePrefix, UploadFileProvider } from 'opensolar-pageeditor/src/files/controller/UploadFileContext'
import { UploadFileFormat } from 'opensolar-pageeditor/src/files/types'
import { IconButton, styled } from 'opensolar-ui'
import CloseIcon from '@material-ui/icons/Close'
import { useSelector } from 'react-redux'

const tester = rankWith(100, and(uiTypeIs('ImageUpload')))

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  marginTop: 10,
  marginBottom: 10,
  gap: 8,
})

const Label = styled(InputLabel)({
  position: 'unset',
})

const PreviewWrapper = styled('div')({
  position: 'relative',
  display: 'inline-block',
  maxWidth: 300,
})

const PreviewImage = styled('img')({
  maxWidth: 300,
  maxHeight: 120,
  objectFit: 'contain',
  borderRadius: 4,
  border: '1px solid #e0e0e0',
})

const RemoveButton = styled(IconButton)({
  position: 'absolute',
  top: -8,
  right: -8,
  backgroundColor: 'white',
  boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
  padding: 4,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
})

const ImageUploadRenderer = (props: ControlProps) => {
  const { path, handleChange, data, label, visible, uischema } = props
  const orgId = useSelector(authSelectors.getOrgId)

  if (!visible) return null

  const resourcePrefix = (uischema?.options?.resourcePrefix as ResourcePrefix) || 'public'
  const formFormat = (uischema?.options?.formFormat as UploadFileFormat) || 'public_url'
  const autoUpload = uischema?.options?.autoUpload !== false
  const showTags = uischema?.options?.showTags === true

  const currentUrl = typeof data === 'string' ? data : ''
  const raSource = `data.${path}`

  const handleClear = () => {
    handleChange(path, '')
  }

  return (
    <Container>
      <Label>{label as string}</Label>
      {currentUrl && (
        <PreviewWrapper>
          <PreviewImage src={currentUrl} alt={label as string} />
          <RemoveButton size="small" onClick={handleClear}>
            <CloseIcon style={{ fontSize: 14 }} />
          </RemoveButton>
        </PreviewWrapper>
      )}
      <UploadFileProvider orgId={orgId || 0}>
        <UploadFileInput
          source={raSource}
          resource_prefix={resourcePrefix}
          formFormat={formFormat}
          autoUpload={autoUpload}
          multiple={false}
          fileTypesAccepted="image/*"
          hideDropzoneWhenPopulated={true}
          showTags={showTags}
          fullWidth={false}
        />
      </UploadFileProvider>
    </Container>
  )
}

const renderer = withJsonFormsControlProps(ImageUploadRenderer)

export default {
  tester,
  renderer,
}
